import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { GtmService } from '../services/gtm';

/**
 * APP_INITIALIZER factory for Google Tag Manager
 *
 * Initializes GTM before the app renders, ensuring tracking
 * is available from the first page load (browser only)
 */
export function initializeGtm(): () => void {
  const gtmService = inject(GtmService);
  const platformId = inject(PLATFORM_ID);

  return () => {
    if (isPlatformBrowser(platformId)) {
      gtmService.initialize();
    }
  };
}
